import api from '../api/axios';

const getAll = () => {
  return api.get('/proposal-sample');
};

const getMy = () => {
  return api.get('/proposal-sample/my');
};

const getById = (id) => {
  return api.get(`/proposal-sample/${id}`);
};

const create = (data) => {
  return api.post('/proposal-sample', data);
};

const update = (id, data) => {
  return api.patch(`/proposal-sample/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/proposal-sample/${id}`);
};

const proposalSampleServices = {
  getAll,
  getMy,
  getById,
  create,
  update,
  remove,
};

export default proposalSampleServices;

